import components from './zh_CN/components';
import pages from './zh_CN/pages';
import seo from './zh_CN/seo';

export default {
  ...pages,
  ...components,
  ...seo,
};
